var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"RFC *","dense":"","outlined":"","hide-details":!_vm.hasError,"error":_vm.hasError,"error-messages":_vm.errorMessage,"value":_vm.value,"loading":_vm.loading,"counter":"","maxlength":_vm.maxLength},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }